import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <div className="bg-gray-900 text-white rounded-2xl p-8 md:p-10 my-12 text-center relative overflow-hidden" data-id="element-40">
      <div className="absolute top-0 left-0 w-full h-2 bg-brand-500" data-id="element-41"></div>
      <ShieldCheckIcon className="w-16 h-16 text-brand-400 mx-auto mb-6" data-id="element-42" />
      <h3 className="font-sans text-2xl md:text-3xl font-bold mb-4" data-id="element-43">
        Garantie Satisfaite ou Remboursée 60 Jours
      </h3>
      <p className="font-serif text-gray-300 text-lg leading-relaxed max-w-xl mx-auto" data-id="element-44">
        Essayez Lissea™ pendant 60 jours. Si vous ne sentez pas de différence
        dans la texture de votre peau — si elle n'est pas plus douce et plus
        lisse au toucher — renvoyez-le et vous serez remboursée intégralement.
        Un simple email suffit.
      </p>
    </div>;
}